// pages/retail-investor/Topics-highlight.tsx
import type { ReactElement } from 'react'
import styled from 'styled-components'

import { theme } from '@/styles/theme'

import { TitleLayout } from '@/components/layout'
import { CompanyLinks } from '@/components/layouts/Company/CompanyLinks'
import { Head } from '@/components/layouts/Head'
import { MonthlySalesPDF } from '@/components/layouts/Ir/Pdffiles'

const TopicsCocotoraPage = () => {
  return (
      <>
        <CompanyMain>
          <CompanyLinks padding={{ pc: '0 0', sp: '0 0' }} />
        </CompanyMain>
      </>
  )
}

export default TopicsCocotoraPage

TopicsCocotoraPage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: '個人投資家の皆様へ', path: '/ir/investor/' },
    { name: 'ココ見てトライアル2025', path: '' }
  ];
  const yearsPdf = [
    {
      accordionTitle: '2024年6月期（2023年7月1日〜2024年6月30日）',
      accordionItems: [{
        id: '',
        fileName: '2024年６月期 TRIALレポート',
        filePath: 'https://report-k.pdcp.jp/141A/202409/a/'
      }],
      isDefaultOpen: true
    }
  ];
  return (
    <>
      <Head
        title="企業情報"
        description="トライアルホールディングスの企業情報を掲載しています。"
        ogp={{ url: 'company/' }}
      />
      <TitleLayout
        title="Investor Relations"
        subTitle="株主・投資家向け情報"
        breadCrumbs={breadCrumbs}
      >
        <TopicsSection>
          <TopicsTitleBuild style={{ marginTop: '20px' }}>株式会社西友</TopicsTitleBuild>
          <SeyuTit>
            <SeyuTitLogo>
              <img src="/images/topics_cocotora_40.png" />
            </SeyuTitLogo>
            <SeyuTitRemark>西友の使命: <span>｢西友が身近にあるしあわせ｣をめざして</span></SeyuTitRemark>
          </SeyuTit>
          <Seiyu>
            <SeiyuLeft>
              <SeiyuLeftCompany>株 式 会 社 西 友</SeiyuLeftCompany>
              <SeiyuLeftInfo>
                <div style={{ overflow: 'hidden' }}>
                  <SeiyuLeftInfoCompany>
                    <SeiyuLeftInfoLine>
                      <SeiyuLeftInfoLineKey>設 立</SeiyuLeftInfoLineKey>
                      <SeiyuLeftInfoLineValue>1963年4月</SeiyuLeftInfoLineValue>
                    </SeiyuLeftInfoLine>
                    <SeiyuLeftInfoLine>
                      <SeiyuLeftInfoLineKey>資本金</SeiyuLeftInfoLineKey>
                      <SeiyuLeftInfoLineValue>1億円</SeiyuLeftInfoLineValue>
                    </SeiyuLeftInfoLine>
                  </SeiyuLeftInfoCompany>
                  <SeiyuRightInfoMember>
                    <SeiyuLeftInfoLine>
                      <SeiyuLeftInfoLineKey>本 社</SeiyuLeftInfoLineKey>
                      <SeiyuLeftInfoLineValue>東京都武蔵野市吉祥寺</SeiyuLeftInfoLineValue>
                    </SeiyuLeftInfoLine>
                    <SeiyuLeftInfoLine>
                      <SeiyuLeftInfoLineKey>従業員数</SeiyuLeftInfoLineKey>
                      <SeiyuLeftInfoTwoLineValue>社員 2,771名<br/>臨時雇用者 16,229名</SeiyuLeftInfoTwoLineValue>
                    </SeiyuLeftInfoLine>
                  </SeiyuRightInfoMember>
                </div>
                <SeiyuLeftInfoLineBottom>
                  <SeiyuLeftInfoLineKey>役 員</SeiyuLeftInfoLineKey>
                  <SeiyuLeftInfoLineValue>代表取締役社長 楢木野 仁司</SeiyuLeftInfoLineValue>
                </SeiyuLeftInfoLineBottom>
                <SeiyuLeftInfoRemark> ※社員：<span>フルタイムワーカーを</span>指<span>す</span> ※2025年６月16日時点</SeiyuLeftInfoRemark>
              </SeiyuLeftInfo>
              <SeiyuMapStore>
                <SeiyuMap>
                  <SeiyuMapInfo>
                    <img src="/images/topics_cocotora_1.png" />
                    <SeiyuMapRemark>
                      <SeiyuMapRemarkLogo>
                        <img src="/images/topics_cocotora_41.png" />
                      </SeiyuMapRemarkLogo>
                      <SeiyuMapRemarkLine>
                        <SeiyuMapRemarkList>
                          <SeiyuMapRemarkListKey>関 東</SeiyuMapRemarkListKey>
                          <SeiyuMapRemarkListValue>135店舗</SeiyuMapRemarkListValue>
                        </SeiyuMapRemarkList>
                        <SeiyuMapRemarkList>
                          <SeiyuMapRemarkListKey>中 部</SeiyuMapRemarkListKey>
                          <SeiyuMapRemarkListValue>72店舗</SeiyuMapRemarkListValue>
                        </SeiyuMapRemarkList>
                        <SeiyuMapRemarkList>
                          <SeiyuMapRemarkListKey>関 西</SeiyuMapRemarkListKey>
                          <SeiyuMapRemarkListValue>19店舗</SeiyuMapRemarkListValue>
                        </SeiyuMapRemarkList>
                        <SeiyuMapRemarkList>
                          <SeiyuMapRemarkListKey>東 北</SeiyuMapRemarkListKey>
                          <SeiyuMapRemarkListValue>19店舗</SeiyuMapRemarkListValue>
                        </SeiyuMapRemarkList>
                      </SeiyuMapRemarkLine>
                      <SeiyuMapRemarkTotal>
                        <SeiyuMapRemarkTotalKey>合 計</SeiyuMapRemarkTotalKey>
                        <SeiyuMapRemarkTotalValue>245店舗</SeiyuMapRemarkTotalValue>
                      </SeiyuMapRemarkTotal>
                    </SeiyuMapRemark>
                  </SeiyuMapInfo>
                </SeiyuMap>
                <SeiyuStore>
                  <SeiyuStoreList>
                    <SeiyuStoreListTit>
                      <SeiyuStoreListLeft>西友</SeiyuStoreListLeft>
                      <SeiyuStoreListRight>LIVIN</SeiyuStoreListRight>
                    </SeiyuStoreListTit>
                    <SeiyuStoreListImg>
                      <SeiyuStoreListTitLeft>
                        <img src="/images/topics_cocotora_2.png" />
                        <SeiyuStoreListImgRemark>
                          <p>アイテム数</p>約<span>６</span>～<span>７</span>万点
                        </SeiyuStoreListImgRemark>
                      </SeiyuStoreListTitLeft>
                      <SeiyuStoreListTitRight>
                        <img src="/images/topics_cocotora_3.png" />
                        <SeiyuStoreListImgRemark>
                          <p>アイテム数</p>約<span>10</span>万点
                        </SeiyuStoreListImgRemark>
                      </SeiyuStoreListTitRight>
                    </SeiyuStoreListImg>
                    <SeiyuStoreListInfo>
                      <SeiyuStoreListLeft>240店舗</SeiyuStoreListLeft>
                      <SeiyuStoreListRight>5店舗</SeiyuStoreListRight>
                    </SeiyuStoreListInfo>
                    <SeiyuStoreListArea>
                      <SeiyuStoreListLeft>約2,000㎡</SeiyuStoreListLeft>
                      <SeiyuStoreListRight>約10,000㎡</SeiyuStoreListRight>
                    </SeiyuStoreListArea>
                    <SeiyuStoreListInfo>
                      <SeiyuStoreListLeft>都市型</SeiyuStoreListLeft>
                      <SeiyuStoreListRight>都市型/郊外型</SeiyuStoreListRight>
                    </SeiyuStoreListInfo>
                  </SeiyuStoreList>
                </SeiyuStore>
              </SeiyuMapStore>
            </SeiyuLeft>
            <SeiyuRight>
              <SeiyuRightTit>西友の特徴４選！</SeiyuRightTit>
              <SeiyuRightBorder>
                <SeiyuRightSelect>生活に根ざした店舗展開</SeiyuRightSelect>
                <SeiyuRightSelectRemark>関東圏を中心に、駅前・住宅立地が多く、日常使いに便利な店舗網を展開。皆さまの暮らしに寄り添う存在。</SeiyuRightSelectRemark>
                <SeiyuRightSelect>いただいた声を商品づくりに</SeiyuRightSelect>
                <SeiyuRightSelectRemark>プライべートブランド「みなさまのお墨付き」では、第三者機関による消費者テストによりお客さまの声を反映した商品開発を実現。</SeiyuRightSelectRemark>
                <SeiyuRightSelect>ユーザー目線のネットスーパー先進企業</SeiyuRightSelect>
                <SeiyuRightSelectRemark>日本で初めてネットスーパーサービスを展開した大手スーパーとして、更なる利便性提供に向けて展開エリア拡大中。</SeiyuRightSelectRemark>
                <SeiyuRightSelect>動き続ける進化企業</SeiyuRightSelect>
                <SeiyuRightSelectRemark>トライアルグループとの融合により、デジタル化を推進。<br/>次世代に向けた新たな挑戦を通じて常に進化を継続。</SeiyuRightSelectRemark>
                <div style={{ height: '15px' }}></div>
              </SeiyuRightBorder>
            </SeiyuRight>
          </Seiyu>
          <SeiyuDevelopment>
            <img src="/images/topics_cocotora_4.png" />
          </SeiyuDevelopment>
          <TopicsScription><span>●</span>「みなさまのお墨付き」商品開発コンセプト</TopicsScription>
          <TopicsScription>
              <p style={{ color: '#2F5597' }}>西友のプライベート・ブランド「みなさまのお墨付き」</p>
          </TopicsScription>
          <TopicsSales>
              <TopicsSalesList>
                  <TopicsSalesListImg>
                      <img src="/images/topics_cocotora_13.png" />
                  </TopicsSalesListImg>
              </TopicsSalesList>
              <TopicsSalesListRemark style={{ width: 'calc(100% - 380px)' }}>
                  <p>おいしい、使いやすいの声、続々。</p>
                  <p>シンボルマークの二重丸は、みなさまからのお墨付きの印。</p>
              </TopicsSalesListRemark>
          </TopicsSales>
          <TopicsDevelop>
            <TopicsDevelopLeft>
              <TopicsDevelopLeftTitle>開 発 手 法</TopicsDevelopLeftTitle>
              <TopicsDevelopLeftInfo>
                <TopicsDevelopLeftRemark>第三者機関による厳正な消費者テストで、<br/><span>80%以上の支持率を獲得した</span><br/>「良いのに、安い」商品だけを提供</TopicsDevelopLeftRemark>
                <TopicsDevelopLeftImg>
                    <img src="/images/topics_cocotora_12.png" />
                </TopicsDevelopLeftImg>
              </TopicsDevelopLeftInfo>
            </TopicsDevelopLeft>
            <TopicsDevelopRight>
              <TopicsDevelopRightTit>注目商品カタログ</TopicsDevelopRightTit>
              <TopicsDevelopRightInfo>
                <TopicsDevelopRightInfoFlex>
                  <img src="/images/topics_cocotora_7.png" />
                  <div><span>●</span>本格レトルトカレーシリーズ</div>
                  <img src="/images/topics_cocotora_9.png" />
                  <div><span>●</span>On the ごはんシリーズ</div>
                  <img src="/images/topics_cocotora_11.png" />
                </TopicsDevelopRightInfoFlex>
                <TopicsDevelopRightInfoFlex>
                  <img src="/images/topics_cocotora_8.png" />
                  <div><span>●</span>厚切りチップスシリーズ</div>
                  <img src="/images/topics_cocotora_10.png" />
                  <div><span>●</span>冷凍食品</div>
                  <img src="/images/topics_cocotora_6.png" />
                </TopicsDevelopRightInfoFlex>
              </TopicsDevelopRightInfo>
            </TopicsDevelopRight>
          </TopicsDevelop>
          <TopicsScription><p>「みなさまのお墨付き」のコンセプトや商品の詳細は<a href="https://www.seiyu.co.jp/pb/mo/" target='_blank' rel="noopener noreferrer">こちら</a>をご覧ください!</p></TopicsScription>

          <TopicsTitlePB>お客さまに愛される商品が生まれるまで<br/><span>PB戦略</span></TopicsTitlePB>
          <TopicsScription><span>●</span>商品開発コンセプト</TopicsScription>
          <TopicsScription>
              <p>ITと職人の経験知で価格以上の価値を伝える『おいしさ』をお届けします。</p>
          </TopicsScription>
          <TopicsSales>
              <TopicsSalesList>
                  <TopicsSalesListImg>
                      <img src="/images/topics_cocotora_15.png" />
                  </TopicsSalesListImg>
              </TopicsSalesList>
              <TopicsSalesListRemark style={{ width: 'calc(100% - 380px)' }}>
                  <p>トライアルは「料理の職人品質をお届けしたい」という想いを込めた「こはく本舗」ブランドのもと、味はもちろん、食材、価格、すべてに感動を呼ぶ「食づくり」に取り組んでいます。</p>
                  <p>価格以上の価値を実感していただける「おいしさ」を、毎日のお客さまの食事に。</p>
                  <p>その「おいしさ」は、立ち止まることなく、進化をつづけます。</p>
              </TopicsSalesListRemark>
          </TopicsSales>
          <img style={{ marginTop: '30px', marginBottom: '20px' }} src="/images/topics_cocotora_14.png" />
          <TopicsScription><span>●</span>かつ重専用調理マシンの独自開発</TopicsScription>
          <TopicsEcharts>
              <TopicsEchartsList>
                  <TopicsEchartsListImg>
                      <img src="/images/topics_cocotora_16.png" />
                  </TopicsEchartsListImg>
                  <TopicsEchartsListTit>職人の繊細な技術・レシピ</TopicsEchartsListTit>
              </TopicsEchartsList>
              <TopicsEchartsList>
                  <TopicsEchartsListImg>
                      <img src="/images/topics_cocotora_17.png" />
                  </TopicsEchartsListImg>
                  <TopicsEchartsListTit>プロの味をデータ化</TopicsEchartsListTit>
              </TopicsEchartsList>
              <TopicsEchartsList>
                  <TopicsEchartsListImg>
                      <img src="/images/topics_cocotora_18.png" />
                  </TopicsEchartsListImg>
                  <TopicsEchartsListTit>データ化された技術を忠実に<br/>再現できる機械を独自開発</TopicsEchartsListTit>
              </TopicsEchartsList>
          </TopicsEcharts>
          <TopicsScription>
              <p style={{ color: '#2F5597' }}>ITと職人の経験知で、専用の調理マシンを独自開発することで、<br/>お客さまに支持されている味を日本全国で再現し、お求めやすい価格で提供</p>
          </TopicsScription>
          <TopicsSales>
              <TopicsSalesList>
                  <TopicsSalesListImg>
                      <img src="/images/topics_cocotora_19.png" />
                  </TopicsSalesListImg>
              </TopicsSalesList>
              <TopicsSalesListRemark>
                  <TopicsSalesListRemarkTit>年間約1,000万食を販売！</TopicsSalesListRemarkTit>
                  <span>素材にもこだわりさらに進化！</span>
                  <p>大手食品加工メーカーとコラボし、お肉の量を増量し、食べ応えがアップ</p>
                  <span>地域の味に密着！</span>
                  <p>東では濃口醤油、西では薄口醤油を使うなど、各地域の皆さまに寄り添った味付け</p>
              </TopicsSalesListRemark>
          </TopicsSales>
          <TopicsScription><span>●</span>協業で生まれたこだわり商品</TopicsScription>
          <TopicsGoods>
              <TopicsGoodsList>
                  <TopicsGoodsListImg>
                      <a href='https://www.trial-net.co.jp/mag/detail/22319/' target='_blank' rel="noopener noreferrer"><img src="/images/topics_cocotora_25.png" /></a>
                  </TopicsGoodsListImg>
              </TopicsGoodsList>
              <TopicsGoodsList>
                  <TopicsGoodsListImg>
                      <a href='https://www.trial-net.co.jp/mag/detail/20871/' target='_blank' rel="noopener noreferrer"><img src="/images/topics_cocotora_26.png" /></a>
                  </TopicsGoodsListImg>
              </TopicsGoodsList>
          </TopicsGoods>
          <TopicsGoods>
              <TopicsGoodsList>
                  <TopicsGoodsListImg>
                      <a href='https://www.trial-net.co.jp/mag/detail/14323/' target='_blank' rel="noopener noreferrer"><img src="/images/topics_cocotora_27.png" /></a>
                  </TopicsGoodsListImg>
              </TopicsGoodsList>
              <TopicsGoodsList>
                  <TopicsGoodsListImg>
                      <a href='https://www.trial-net.co.jp/mag/detail/21051/' target='_blank' rel="noopener noreferrer"><img src="/images/topics_cocotora_28.png" /></a>
                  </TopicsGoodsListImg>
              </TopicsGoodsList>
          </TopicsGoods>
          <TopicsGoods>
              <TopicsGoodsList>
                  <TopicsGoodsListImg>
                      <a href='https://www.trial-net.co.jp/mag/detail/13366/' target='_blank' rel="noopener noreferrer"><img src="/images/topics_cocotora_29.png" /></a>
                  </TopicsGoodsListImg>
              </TopicsGoodsList>
              <TopicsGoodsList>
                
                  <TopicsGoodsListImg>
                      <a href='https://www.trial-net.co.jp/mag/detail/19477/' target='_blank' rel="noopener noreferrer"><img src="/images/topics_cocotora_30.png" /></a>
                  </TopicsGoodsListImg>
              </TopicsGoodsList>
          </TopicsGoods>
          <TopicsSales>
              <TopicsSalesList>
                  <TopicsSalesListImg>
                      <a href="https://www.trial-net.co.jp/mag/" target='_blank' rel="noopener noreferrer"><img src="/images/topics_cocotora_31.png" /></a>
                  </TopicsSalesListImg>
              </TopicsSalesList>
              <TopicsSalesListRemark style={{ width: 'calc(100% - 380px)' }}>
                  <p>その他、Webマガジン「くらしトライ」にて、おすすめの商品や生活に役立つ情報を発信しておりますので、是非ご覧ください！</p>
              </TopicsSalesListRemark>
          </TopicsSales>
          <TopicsTitleBuild>リテールテックを活用した流通エコシステムの構築</TopicsTitleBuild>
          <TopicsScription>
              <p>トライアルが取得し、整理・分析したデータをメーカー、卸、物流、小売間でシームレスに共有することで、業界全体の流通エコシステムを構築</p>
          </TopicsScription>
          <img style={{ marginTop: '30px' }} src="/images/topics_cocotora_20.png" />
          <TopicsImgRemark>※ 当社の分析に基づくイメージ図</TopicsImgRemark>
          <TopicsScription style={{ marginTop: '45px' }}><span>●</span>協業で目指す流通情報革命</TopicsScription>
          <img style={{ marginTop: '35px' }} src="/images/topics_cocotora_21.png" />
          <img src="/images/topics_cocotora_22.png" />
          <img src="/images/topics_cocotora_23.png" />
          <TopicsScription style={{ marginTop: '45px' }}><span>●</span>流通小売業界の「ムダ･ムラ･ムリ」の解消による業界変革</TopicsScription>
          <img style={{ marginTop: '30px' }} src="/images/topics_cocotora_24.png" />
          <TopicsImg24Remark>
            <TopicsImg24RemarkInfo>
              *1 経済産業省「商業動態統計」2024年度
            </TopicsImg24RemarkInfo>
            <TopicsImg24RemarkInfo>
              *2 当社は、流通小売業界には多くの「ムダ･ムラ･ムリ」が存在していると考えております。当社は、欠品／ロス、R&D、支店／商談、広告、リベートに係るコストを広く合算した総額は約40兆円にのぼると試算しており、国内の流通小売業の売上高165兆円との対比でも、かかる「ムダ･ムラ･ムリ」の大きさが見て取れると考えております。
            </TopicsImg24RemarkInfo>
            <TopicsImg24RemarkInfoTxt>・欠品/ロス：飲食料品業界の食品廃棄額、資産ロス（万引・不正・管理ミスによる損失）及び機会ロス（欠品による売上高の減少）の合計。食品廃棄額は経済産業省「商業動態統計」（2024年度）及び全国スーパーマーケット協会「スーパーマーケット年次統計調査報告書」（2024年10月）から推計、資産ロスは経済産業省「商業動態統計」（2024年度）及び全国万引犯罪防止機構「第14回全国小売業不明ロス・店舗セキュリティ実態調査分析報告書」（2024年４月）から推計､機会ロスは経済産業省「商業動態統計」（2024年度）ほか及びDaniel Corsten, Thomas Gruen 「On Shelf Availability: An Examination of the Extent, the Causes, and the Efforts to Address Retail Out-of-Stocks」(2005) （欠品による売上高の減少率（世界平均）） から推計</TopicsImg24RemarkInfoTxt>
            <TopicsImg24RemarkInfoTxt>・R&D：食品飲料メーカー、消費財メーカー及び衣食関連の卸・小売に係る研究開発費及び研究開発部門の人件費総額の合計。食品飲料・消費財メーカーに係る研究開発費は上場企業の開示データ（出所：Quick）における「研究開発費」を集計</TopicsImg24RemarkInfoTxt>
            <TopicsImg24RemarkInfoTxt>して推計、衣食関連の卸・小売に係る研究開発費は経済産業省「企業活動基本調査」（2023年度）から推計。人件費総額は経済産業省「企業活動基本調査」（2023年度）を基にR&D部門の推定人員数×一人当たり推定人件費総額で試算</TopicsImg24RemarkInfoTxt>
            <TopicsImg24RemarkInfoTxt>・支店/商談：日本全国に支店を構え、営業拠点が点在すること及び個別商談を行うことによる非効率性を指す。経済産業省「商業動態統計」（2024年度）及び日本ロジスティクスシステム協会「物流コスト調査」（2024年度）等から推計</TopicsImg24RemarkInfoTxt>
            <TopicsImg24RemarkInfoTxt>・広告：日本の総広告費であり、電通｢2024年日本の広告費｣に基づく</TopicsImg24RemarkInfoTxt>
            <TopicsImg24RemarkInfoTxt>・リベート：消費財メーカーの販促費用の合計であり、経済産業省「工業統計調査」（2020年度）及びデロイトトーマツ「消費財メーカーにおける販促費用最適化:ゼロベース予算を活用した最適化アプローチ」から推計
            </TopicsImg24RemarkInfoTxt>
            <TopicsImg24RemarkInfoTxt>・One to Oneマーケティング: 消費者個別の購買傾向及び属性等からニーズを読み取り、個々に対して最適なコミュニケーションを行うマーケティング活動
            </TopicsImg24RemarkInfoTxt>
          </TopicsImg24Remark>
          <MonthlySalesPDF yearsPdf={yearsPdf} />
        </TopicsSection>
      </TitleLayout>
    </>
  )
}
const CompanyMain = styled.div`
  width: 1040px;
  margin: 0 auto;
  padding: 98px 0 130px;

  @media screen and (max-width: 1047px) {
    width: 100%;
    padding: 40px 20px 70px;
  }
`
const TopicsSection = styled.div`
  width: 1040px;
  margin: 0 auto;
  padding: 30px 0 130px;
  img {
    width: 100%;
  }
  @media screen and (max-width: 1047px) {
    width: 100%;
    padding: 40px 20px 70px;
  }
`

const TopicsTitleBuild = styled.p`
  width: 100%;
  padding: 15px 10px;
  font-size: 32px;
  font-weight: bold;
  color: #FFF;
  margin-top: 150px;
  background: ${theme.colors.trialBlue};
  @media screen and (max-width: 1047px) {
    font-size: 17px;
    line-height: 19px;
    margin-top: 100px;
  }
`

const TopicsTitlePB = styled.div`
  width: 100%;
  min-height: 135px;
  line-height: 58px;    
  font-size: 32px;
  font-weight: bold;
  text-indent: 10px;
  color: #FFF;
  margin-top: 150px;
  background: ${theme.colors.trialBlue};
  span {
    font-size: 46px;margin-left: 15px;
  }
  @media screen and (max-width: 1047px) {
    font-size: 17px;
    height: 40px;
    line-height: 38px;
    min-height: 90px;
    margin-top: 100px;
    span {
      font-size: 30px;margin-left: 10px;
    }
  }
`

const TopicsScription = styled.div`
  margin-top: 30px;
  font-size: 26px;
  line-height: 34px;
  font-weight: bold;
  overflow: hidden;
  span {
    margin-right: 8px;
  }
  p {
    margin-top: 10px;
    font-size: 20px;
    letter-spacing: 1px;
  }
  a {
    color: ${theme.colors.trialBlue};
    text-decoration: underline;
  }
  @media screen and (max-width: 1047px) {
    font-size: 16px;
    line-height: 23px;
    margin-top: 12px;
    span {
      margin-right: 5px;
    }
    p {
      font-size: 16px;
      line-height: 26px;
    }
  }
`

const TopicsEcharts = styled.div`
  display: flex;
  width: 100%;
  @media screen and (max-width: 1040px) {
    display: block;
  }
`

const TopicsEchartsList = styled.div`
  flex: 1;
`


const TopicsEchartsListTit = styled.div`
  line-height: 24px;
  font-size: 20px;
  font-weight: bold;
  height: 70px;
  text-align: center;
  @media screen and (max-width: 1040px) {
    font-size: 14px;
    line-height: 20px;
    height: 40px;
  }
`

const TopicsEchartsListImg = styled.div`
  max-width: 340px;
  width: 100%;
  margin: 0 auto;
`

const TopicsGoods = styled.div`
  display: flex;
  gap: 40px;
  width: 100%;
  @media screen and (max-width: 1040px) {
    display: block;
  }
`

const TopicsGoodsList = styled.div`
  flex: 1;
`

const TopicsGoodsListImg = styled.div`
  width: 100%;
  margin: 0 auto;
  margin-top: 30px;
`

const TopicsImgRemark = styled.div`
  font-size: 12px;
  color: #333;
  margin-top: 8px;
`

const TopicsSales = styled.div`
  width: 100%;
  margin-top: 50px;
  overflow: hidden;
  @media screen and (max-width: 1040px) {
      margin-top: 30px;
  }
`

const TopicsSalesList = styled.div`
  width: 350px;
  float: left;
  @media screen and (max-width: 1040px) {
      width: 100%;
      max-width: 350px;
  }
`

const TopicsSalesListRemark = styled.div`
  float: left;
  margin-left: 30px;
  font-size: 17px;
  line-height: 40px;
  span {
      font-weight: bold;
  }
  @media screen and (max-width: 1040px) {
      width: 100% !important;
      margin-left: 0;
      margin-top: 10px;
      font-size: 14px;
      p {
          line-height: 24px;
      }
  }
`

const TopicsSalesListRemarkTit = styled.div`
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
  margin-top: 5px;
  @media screen and (max-width: 1040px) {
      font-size: 18px;
      margin-bottom: 0;
  }
`

const TopicsSalesListImg = styled.div`
  max-width: 350px;
  width: 100%;
  margin: 0 auto;
`

const SeyuTit = styled.div`
  overflow: hidden;
  margin-top: 50px;
  @media screen and (max-width: 1040px) {
    margin-top: 0px;
  }
`

const Seiyu = styled.div`
  overflow: hidden;
  margin-top: 20px;
`

const SeyuTitLogo = styled.div`
  overflow: hidden;
  float: left;
  img {
    width: 170px;
  }
  @media screen and (max-width: 1040px) {
    margin-top: 30px;
    img {
      width: 100px;
    }
  }
`

const SeyuTitRemark = styled.div`
  font-size: 16px;
  font-weight: bold;
  float: left;
  margin-left: 58px;
  margin-top: 9px;
  span {
    font-size: 24px;
  }
  @media screen and (max-width: 1040px) {
    font-size: 14px;
    span {
      font-size: 15px;
    };
    margin-top: 20px;
    margin-left: 0;
  }
`

const SeiyuLeft = styled.div`
  width: 530px;
  float: left;
  @media screen and (max-width: 1040px) {
    width: 100%;
  }
`

const SeiyuLeftCompany = styled.div`
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  color: #FFF;
  background: #C00000;
  line-height: 28px;
  @media screen and (max-width: 1040px) {
    font-size: 16px;
    line-height: 26px;
  }
`

const SeiyuLeftInfo = styled.div`
  border: 1px solid #C00000;
  overflow: hidden;
`

const SeiyuLeftInfoCompany = styled.div`
  float: left;
  width: 45%;
  @media screen and (max-width: 1040px) {
    width: 100%;
  }
`

const SeiyuLeftInfoLine = styled.div`
  overflow: hidden;
  font-size: 16px;
  font-weight: bold;
  margin-top: 15px;
`

const SeiyuLeftInfoLineBottom = styled.div`
  overflow: hidden;
  font-size: 16px;
  font-weight: bold;
  @media screen and (max-width: 1040px) {
    margin-top: 15px;
  }
`

const SeiyuLeftInfoLineKey = styled.div`
  margin-left: 15px;
  width: 80px;
  float: left;
  @media screen and (max-width: 1040px) {
    width: 80px;
  }
`

const SeiyuLeftInfoLineValue = styled.div`
  float: left;
  font-size: 14px;
  font-weight: normal;
`

const SeiyuLeftInfoTwoLineValue = styled.div`
  width: 55%;
  float: left;
  font-size: 14px;
  font-weight: normal;
  line-height: 16px;
  @media screen and (max-width: 1040px) {
    width: 52%;
  }
`

const SeiyuLeftInfoRemark = styled.div`
  clear: both;
  width: 95%;
  font-size: 11px;
  padding-top: 10px;
  text-align: right;
  margin-bottom: 8px;
  @media screen and (max-width: 1040px) {
    text-align: center;
    width: 100%;
  }
`

const SeiyuRightInfoMember = styled.div`
  float: left;
  width: 55%;
  @media screen and (max-width: 1040px) {
    width: 100%;
  }
`

const SeiyuMapStore = styled.div`
  overflow: hidden;
`

const SeiyuMap = styled.div`
  width: 280px;
  overflow: hidden;
  float: left;
  @media screen and (max-width: 1040px) {
    width: 100%;
    float: none;
  }
`

const SeiyuMapInfo = styled.div`
  width: 280px;
  overflow: hidden;
  margin: 0 auto;
  position: relative;
  margin-top: 7px;
  img  {
    width: 280px;
  }
  @media screen and (max-width: 1040px) {
    font-size: 16px;
    line-height: 22px;
    width: auto;
    max-width: 280px;
    img  {
      width: 100%;
      max-width: 280px;
    }
  }
`

const SeiyuMapRemark = styled.div`
  width: 150px;
  position: absolute;
  top: 0;
  left: 0;
`

const SeiyuMapRemarkLogo = styled.div`
  img {
    width: 40px;
  }
`

const SeiyuMapRemarkLine = styled.div`
  font-size: 12px;
  line-height: 16px;
  font-weight: bold;
  padding-top: 8px;
  padding-bottom: 8px;
  margin-top: 6px;
  border-top: 1px solid #BFBFBF;
  border-bottom: 1px solid #BFBFBF;
  
  @media screen and (max-width: 1040px) {
    margin-top: 3px;
  }
`

const SeiyuMapRemarkList = styled.div`
  overflow: hidden;
`

const SeiyuMapRemarkListKey = styled.div`
  width: 42%;
  text-align: center;
  float: left;
`

const SeiyuMapRemarkListValue = styled.div`
  width: 58%;
  text-align: center;
  float: left;
`

const SeiyuMapRemarkTotal = styled.div`
  overflow: hidden;
  margin-top: 10px;
  font-weight: bold;
  color: #C00000;
`

const SeiyuMapRemarkTotalKey = styled.div`
  width: 34%;
  text-align: center;
  float: left;
`

const SeiyuMapRemarkTotalValue = styled.div`
  width: 66%;
  text-align: center;
  float: left;
`


const SeiyuStore = styled.div`
  width: 232px;
  overflow: hidden;
  float: right;
  @media screen and (max-width: 1040px) {
    width: 100%;
    float: none;
  }
`

const SeiyuStoreList = styled.div`
  width: 220px;
  overflow: hidden;
  margin: 0 auto;
  margin-top: 20px;
  @media screen and (max-width: 1040px) {
    width: 80%;
  }
`

const SeiyuStoreListTit = styled.div`
  line-height: 40px;
  font-size: 16px;
  color: #C00000;
  text-align: center;
  overflow:hidden;
  @media screen and (max-width: 1040px) {
    font-size: 14px;
    line-height: 22px;
  }
`

const SeiyuStoreListLeft = styled.div`
  width: 110px;
  float: left;
  text-align: center;
  font-weight: bold;
  
`

const SeiyuStoreListRight = styled.div`
  width: 100px;
  float: right;
  text-align: center;
  font-weight: bold;
`

const SeiyuStoreListImg = styled.div`
  overflow: hidden;
  padding-bottom: 10px;
  bottom: 1px solid #BFBFBF;

  @media screen and (max-width: 1040px) {
    font-size: 14px;
    line-height: 22px;
  }
`

const SeiyuStoreListTitLeft = styled.div`
  width: 110px;
  float: left;
  position: relative;
  img {
    width: 100%;
  }

  @media screen and (max-width: 1040px) {
    font-size: 14px;
    line-height: 22px;
  }
`


const SeiyuStoreListTitRight = styled.div`
  width: 100px;
  float: right;
  position: relative;
  img {
    width: 100%;
  }

  @media screen and (max-width: 1040px) {
    font-size: 14px;
    line-height: 22px;
  }
`

const SeiyuStoreListImgRemark = styled.div`
  width: 56px;
  height: 22px;
  right: 2px;
  bottom: 2px;
  background: #FFF;
  line-height: 10px;
  margin-top: 1px;
  text-align: center;
  font-size: 8px;
  position: absolute;
  img {
    width: 100%;
  }
  p {
    font-weight: bold;
  }
  span {
    font-weight: bold;font-size: 10px;
  }
`

const SeiyuStoreListInfo = styled.div`
  line-height: 34px;
  position: relative;
  border-top: 1px solid #BFBFBF;
  border-bottom: 1px solid #BFBFBF;
  overflow: hidden;
  font-size: 13px;
`

const SeiyuStoreListArea = styled.div`
  line-height: 34px;
  overflow: hidden;
  font-size: 13px;
`

const SeiyuRight = styled.div`
  width: 485px;
  float: right;
  @media screen and (max-width: 1040px) {
    width: 100%;
  }
`
const SeiyuRightTit = styled.div`
  font-size: 24px;
  width: 210px;
  text-align: center;
  margin: 0 auto;
  background: #FFF;
  font-weight: bold;
  position: relative;
  z-index: 1;
  @media screen and (max-width: 1040px) {
    width: 100%;
    font-size: 16px;
    margin-top: 35px;
    width: 160px;
  }
`

const SeiyuRightBorder = styled.div`
  border: 1px solid #7A7A7A;
  padding-left: 17px;
  padding-right: 17px;
  padding-top: 5px;
  margin-top: -12px;
  @media screen and (max-width: 1040px) {
    margin-top: -8px;
  }
`

const SeiyuRightSelect = styled.div`
  font-size: 18px;
  margin-top: 25px;
  color: #C00000;
  font-weight: bold;
  @media screen and (max-width: 1040px) {
    font-size: 14px;
  }
`

const SeiyuRightSelectRemark = styled.div`
  font-size: 16px;
  line-height: 22px;
  margin-top: 5px;
  @media screen and (max-width: 1040px) {
    font-size: 12px;
    line-height: 18px;
    margin-top: 3px;
  }
`

const SeiyuDevelopment = styled.div`
  width: 100%;
  height: auto;
  margin-top: 20px;
  margin-bottom: 40px;
  @media screen and (max-width: 767px) {
    height: auto;
    overflow: auto;
    margin-top: 20px;
    img {
      width: auto;height: auto;
    }
  }
`
const TopicsDevelop = styled.div`
  overflow: hidden;
  margin-top: 20px;
`
const TopicsDevelopLeft = styled.div`
  width: 500px;
  float: left;
  @media screen and (max-width: 1040px) {
    width: 100%;
  }
`

const TopicsDevelopLeftTitle = styled.div`
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  color: #FFF;
  background: ${theme.colors.trialBlue};
  line-height: 44px;
  @media screen and (max-width: 1040px) {
    font-size: 16px;
    line-height: 32px;
  }
`

const TopicsDevelopLeftInfo = styled.div`
  border: 1px solid ${theme.colors.trialBlue};
  overflow: hidden;
  padding: 20px 30px;
`

const TopicsDevelopLeftRemark = styled.p`
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  line-height: 22px;
  span {
    color: #FF0000;
  }
  @media screen and (max-width: 767px) {
    font-size: 14px;
    line-height: 20px;
  }
`

const TopicsDevelopLeftImg = styled.div`
  max-width: 350px;
  width: 100%;
  margin: 0 auto;
  margin-top: 20px;
`
const TopicsDevelopRight = styled.div`
  width: 510px;
  float: right;
  @media screen and (max-width: 1040px) {
    width: 100%;
  }
`
const TopicsDevelopRightTit = styled.div`
  line-height: 42px;
  font-size: 20px;
  font-weight: bold;
  border-bottom: 3px solid #333;
  @media screen and (max-width: 1040px) {
    width: 100%;
    font-size: 16px;
  }
`

const TopicsDevelopRightInfo = styled.div`
  display: flex;
  gap: 30px;
  @media screen and (max-width: 1040px) {
    width: 100%;
    font-size: 16px;
    display: block;
  }
`

const TopicsDevelopRightInfoFlex = styled.div`
  padding-top: 11px;
  flex: 1;
    text-align: center;
  div {
    text-align: left;
    margin-top: 12px;
    font-size: 16px;
    font-weight: bold;
    span {
      margin-right: 15px;
    }
  }
  img {
    margin-top: 12px;
    width: auto;
    max-width: 100%;
    max-height: 131px;
  }
  @media screen and (max-width: 1040px) {
    img {
      width: 100%;height: auto;max-height: 300px;
    }
  }
`

const TopicsImg24Remark = styled.div`
  margin-top: 40px;
  font-size: 12px;
  margin-bottom: 50px;
  @media screen and (max-width: 1040px) {
    margin-top: 20px;
  }
`

const TopicsImg24RemarkInfo = styled.p`
  margin: 0;              /* 清除默认外边距 */
  padding-left: 16px;      /* 给整体段落留出缩进 */
  text-indent: -16px;      /* 把第一行拉回去，保持顶格 */
  white-space: normal;    /* 确保能自动换行 */
  word-wrap: break-word;  /* 长单词/链接也能换行 */
  line-height: 16px;
`

const TopicsImg24RemarkInfoTxt = styled.p`
  margin-left: 16px;              /* 清除默认外边距 */
  padding-left: 16px;      /* 给整体段落留出缩进 */
  text-indent: -16px;      /* 把第一行拉回去，保持顶格 */
  white-space: normal;    /* 确保能自动换行 */
  word-wrap: break-word;  /* 长单词/链接也能换行 */
  line-height: 16px;
`